module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Italic.woff?9cbb8f0b741188bd13ba0ee213bb2526";